import React, { useState } from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

import AddCallSheetFormView from './AddCallSheetFormView';
import AddCallSheetProjectView from './AddCallSheetProjectView';
import AddCallSheetSearchView from './AddCallSheetSearchView';

const Wrapper = styled.div``;

const AddCallSheet = ({ onTouchForm, onClose, onUpdateCallSheet, callSheetType, currentProject, callsheet }) => {
    const [view, setView] = useState(callsheet ? 'form' : 'project'); // search, project, form
    const [selectedConnection, setSelectedConnection] = useState();

    return (
        <Wrapper>
            <Segmented
                size="large"
                options={[
                    { label: 'Project Contacts', value: 'project' },
                    { label: 'Search Contacts', value: 'search' },
                    { label: callsheet ? 'Change Details' : 'Add Details', value: 'form' },
                ]}
                value={view}
                onChange={setView}
            />

            {view === 'project' && (
                <AddCallSheetProjectView
                    currentProject={currentProject}
                    onChangeView={setView}
                    onSelectConnection={setSelectedConnection}
                />
            )}

            {view === 'search' && (
                <AddCallSheetSearchView onChangeView={setView} onSelectConnection={setSelectedConnection} />
            )}

            {view === 'form' && (
                <AddCallSheetFormView
                    selectedConnection={selectedConnection}
                    onClose={onClose}
                    onTouchForm={onTouchForm}
                    onUpdateCallSheet={onUpdateCallSheet}
                    callSheetType={callSheetType}
                    projectID={currentProject.ID}
                    callsheet={callsheet}
                    onChangeView={setView}
                />
            )}
        </Wrapper>
    );
};

export default AddCallSheet;
